export const cities = [
  { label: "Makkah", value: 1 },
  { label: "Madinah", value: 2 },
];
